import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { AlertLogRow } from "../types/alertLogs";

dayjs.extend(utc);

const LINK_WINDOW_DAYS = 30;

/**
 * Deep-link from an alert log row's provider_alert_key to that alert's list page.
 *
 * Each list page reads its own query params, so the string differs by source:
 *   - ethoca / verifi_cdrn → search + tab; tab=all clears the status filter
 *   - verifi_rdr           → caseId + subStatus; empty subStatus clears the filter
 *     (an absent subStatus defaults the page to action_needed only)
 */
export function buildProviderAlertLink(row: Pick<AlertLogRow, "alert_source" | "provider_alert_key" | "created_at">): string {
  const key = row.provider_alert_key ?? "";
  const created = dayjs.utc(row.created_at);
  const cappedEnd = created.add(LINK_WINDOW_DAYS, "day");
  const startDate = created.subtract(LINK_WINDOW_DAYS, "day").format("YYYY-MM-DD");
  const endDate = (dayjs.utc().isAfter(cappedEnd) ? dayjs.utc() : cappedEnd).format("YYYY-MM-DD");

  const params = new URLSearchParams({ startDate, endDate });

  if (row.alert_source === "verifi_rdr") {
    params.set("caseId", key);
    params.set("subStatus", "");
    return `/alerts/rdr-notices?${params.toString()}`;
  }

  params.set("search", key);
  params.set("tab", "all");
  const basePath = row.alert_source === "ethoca" ? "/alerts/ethoca" : "/alerts/cdrn";
  return `${basePath}?${params.toString()}`;
}
